import type { PreviewEntry } from '../trustCenterTypes'
import type { ProcessedEntry } from '../../ProcessedEntry/DomainEntry/processedTypes'
import { parseDbTimestamp } from '@/lib/dates'

export function fmtDatePt(iso: string): string {
  const d = parseDbTimestamp(iso)
  return d ? d.toLocaleDateString('pt-PT', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '—'
}

export function processedToPreview(e: ProcessedEntry): PreviewEntry {
  const title = e.headline ?? e.title ?? e.processedInputDescription?.slice(0, 80) ?? 'Denúncia'
  const parts: string[] = []
  if (e.sender) parts.push(`Remetente: ${e.sender}`)
  if (e.messageContent) parts.push(e.messageContent)
  if (e.processedInputDescription && e.processedInputDescription !== e.messageContent)
    parts.push(e.processedInputDescription)
  return {
    date: fmtDatePt(e.createdAt),
    title,
    paragraphs: parts.length ? parts : ['Sem detalhes disponíveis.'],
    images: [],
  }
}
